// extracted by mini-css-extract-plugin
module.exports = {"context-menu-group":"context-menu-group_context-menu-group__2BQQv","context-menu-title":"context-menu-group_context-menu-title__YQUDy"};